import{jsx as r}from"react/jsx-runtime";import{styled as o}from"styled-components";import{getFileDownloadUrl as e}from"../repositories/index.mjs";import{downloadFile as i}from"../services/downloadFile.mjs";import{useTry as t}from"../../../hooks/useTry.mjs";const n=o.a`
  padding-right: 5px;
  margin: 5px 2px;
  padding-right: 18px;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;function m({fileName:o,children:m}){const{wrapRequestInTry:s}=t();return r(n,{onClick:s((async()=>i(await e(o)))),children:m})}export{m as FileDownloadAnchor};
